import { useQuery } from '@tanstack/react-query';
import { apiFetch } from './client.ts';
import { queryDefaults } from './queries.ts';
import { useSession } from '../auth/session.tsx';
import type { CourtOrderForm } from './types.ts';

/**
 * What the court order form chooses from: catalogues, and this client's
 * appointments and earlier orders.
 *
 * Asked only once the form is opened — it is not what a client's page is
 * opened for — and keyed under the client, so recording an order refreshes
 * the appointments and orders it offers next time.
 */
export function useCourtOrderForm(clientId: string, enabled: boolean) {
  const { getToken } = useSession();
  return useQuery({
    queryKey: ['client', clientId, 'court-order-form'],
    queryFn: () =>
      apiFetch<CourtOrderForm>(`/court_orders/form?client_id=${clientId}`, getToken),
    ...queryDefaults,
    enabled,
  });
}
